export default [
    '20 20',
    '<g clip-path="url(#clip0_1488_884)">\n' +
    '<path d="M9.9974 13.3337V10.0003M9.9974 6.66699H10.0057M18.3307 10.0003C18.3307 14.6027 14.5998 18.3337 9.9974 18.3337C5.39502 18.3337 1.66406 14.6027 1.66406 10.0003C1.66406 5.39795 5.39502 1.66699 9.9974 1.66699C14.5998 1.66699 18.3307 5.39795 18.3307 10.0003Z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>\n' +
    '</g>\n' +
    '<defs>\n' +
    '<clipPath id="clip0_1488_884">\n' +
    '<rect width="20" height="20" fill="currentColor"/>\n' +
    '</clipPath>\n' +
    '</defs>'
]